import { Outlet } from 'react-router'
import type { JSX } from 'react'
import { OnboardingProvider } from './OnboardingProvider'

/**
 * Where the wizard state starts being available: inside `RequireTenant`.
 *
 * A route element rather than a provider in `App.tsx`, because
 * `GET /api/v1/onboarding` needs an organisation selected on the session and
 * would answer `TENANT_NOT_SELECTED` for everyone who has not chosen one yet.
 * Mounting it here means the request is made exactly once, by exactly the people
 * it can succeed for — and both the wizard and the shell's setup banner read the
 * same copy of it.
 */
export function OnboardingBoundary(): JSX.Element {
  return (
    <OnboardingProvider>
      <Outlet />
    </OnboardingProvider>
  )
}
